import React from 'react';

const Logo = ({ 
  size = 'md', 
  variant = 'full', 
  className = '',
  showText = true 
}) => {
  const sizes = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8', 
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const textSizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-lg', 
    lg: 'text-xl',
    xl: 'text-2xl'
  };

  if (variant === 'icon') {
    return (
      <div className={`${sizes[size]} ${className} relative`}>
        <img 
          src="/valeon-logo-icon.svg"
          alt="Valeon"
          className="w-full h-full object-contain"
        />
      </div>
    );
  }

  if (variant === 'circular') {
    return (
      <div className={`${sizes[size]} ${className} relative`}>
        <div className="w-full h-full bg-gradient-to-br from-accent-blue to-accent-gold rounded-full p-1">
          <div className="w-full h-full bg-primary-900 rounded-full flex items-center justify-center">
            <img 
              src="/valeon-logo-icon.svg"
              alt="Valeon"
              className="w-3/4 h-3/4 object-contain"
            />
          </div>
        </div>
      </div>
    );
  }

  // Full logo with text
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className={sizes[size]}>
        <img 
          src="/valeon-logo-icon.svg"
          alt="Valeon"
          className="w-full h-full object-contain"
        />
      </div>
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSizes[size]} font-serif font-bold text-cream-100 tracking-tight`}>
            Valeon
          </span>
          <span className="text-xs text-cream-300 -mt-1 tracking-widest uppercase">
            Strategic Advisory
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;